/**
 * Custom JS by RoarTheme Agent
 * https://haloroar.ticksy.com
 * App: RT: Terms and Conditions Box
 */
document.addEventListener("DOMContentLoaded", function () {
  const configuration = {
    widget: document.querySelectorAll(".rale-widget"),
    links: {
      link: "link",
      link1: "link-1758737801379",
    },
  };
  const legalConfigJson = window.roarJs.LegalConfig.metafields?.settings || {};
  if (legalConfigJson?.enabled === "1") {
    const param = legalConfigJson.param;
    const keys = {
      message: "message",
      error: "error_message",
    };
    if (Shopify.locale !== "en") {
      switch (Shopify.locale) {
        case "fr":
          param[
            keys.message
          ] = `J'accepte les {${configuration.links.link}} et la {${configuration.links.link1}}.`;
          param[keys.error] =
            "Veuillez accepter les Termes & Conditions et la Politique de Protection des Données avant de procéder à l'achat !";
          param.links[configuration.links.link].label =
            "Conditions générales de vente";
          param.links[configuration.links.link1].label =
            "Politique de protection des données";
          break;
        case "de":
          param[
            keys.message
          ] = `Ich akzeptiere die {${configuration.links.link}} und die {${configuration.links.link1}}.`;
          param[
            keys.error
          ] = `Bitte stimmen Sie den Allgemeinen Geschäftsbedingungen und der Datenschutzrichtlinie zu, bevor Sie einen Kauf tätigen!`;
          param.links[configuration.links.link].label =
            "Allgemeinen Geschäftsbedingungen";
          param.links[configuration.links.link1].label =
            "Datenschutzrichtlinie";
          break;
        case "it":
          param[
            keys.message
          ] = `Accetto le {${configuration.links.link}} e l'{${configuration.links.link1}}`;
          param[
            keys.error
          ] = `Accetta i Termini & Condizioni e l'Informativa sulla Protezione dei Dati prima di effettuare un acquisto!`;
          param.links[configuration.links.link].label =
            "Condizioni Generali di Vendita";
          param.links[configuration.links.link1].label =
            "Informativa sulla Protezione dei Dati";
          break;
      }

      legalConfigJson.param = param;
    }

    window.roarJs.LegalConfig.metafields.settings = legalConfigJson;
    configuration.widget.forEach((w) => w.remove());
    window.roarJs.Legal.init();
  }
});
